<div class="gallery-wrapper">
    <div
        *ngIf="big?.length > 0"
        class="gallery">
        <div class="gallery__stage">
            <button
                *ngIf="big.length > 1"
                (click)="previous()"
                aria-label="Previous image"
                class="gallery__arrow gallery__arrow--prev"
                type="button">
                <i class="las la-chevron-circle-left"></i>
            </button>

            <img
                (click)="openPreview()"
                [alt]="'Image ' + (current + 1) + ' of ' + big.length"
                [src]="displayed"
                class="gallery__image" />

            <button
                *ngIf="big.length > 1"
                (click)="next()"
                aria-label="Next image"
                class="gallery__arrow gallery__arrow--next"
                type="button">
                <i class="las la-chevron-circle-right"></i>
            </button>
        </div>

        <div
            *ngIf="big.length > 1"
            class="gallery__thumbnails">
            <img
                *ngFor="let image of big; let i = index"
                (click)="select(i)"
                [alt]="'Thumbnail ' + (i + 1)"
                [class.gallery__thumbnail--active]="i === current"
                [src]="thumbnail(i)"
                class="gallery__thumbnail" />
        </div>
    </div>
</div>

<div
    *ngIf="previewOpen"
    (click)="closePreview()"
    class="gallery__preview">
    <button
        (click)="closePreview()"
        aria-label="Close preview"
        class="gallery__close"
        type="button">
        <i class="las la-times-circle"></i>
    </button>

    <button
        *ngIf="big.length > 1"
        (click)="previous(); $event.stopPropagation()"
        aria-label="Previous image"
        class="gallery__arrow gallery__arrow--prev"
        type="button">
        <i class="las la-chevron-circle-left"></i>
    </button>

    <img
        (click)="$event.stopPropagation()"
        [alt]="'Image ' + (current + 1) + ' of ' + big.length"
        [src]="displayed"
        class="gallery__preview-image" />

    <button
        *ngIf="big.length > 1"
        (click)="next(); $event.stopPropagation()"
        aria-label="Next image"
        class="gallery__arrow gallery__arrow--next"
        type="button">
        <i class="las la-chevron-circle-right"></i>
    </button>
</div>
